(()=>{
  const inflect=count=>count===1?'1 typ pokoju':count>=2&&count<=4?`${count} typy pokoi`:`${count} typów pokoi`;

  const initRoot=root=>{
    if(root.dataset.roomCatalogReady==='true')return;
    root.dataset.roomCatalogReady='true';
    const buttons=[...root.querySelectorAll('[data-room-filter]')];
    const cards=[...root.querySelectorAll('[data-room-card]')];
    const label=root.querySelector('[data-room-results-label]');
    const count=root.querySelector('[data-room-results-count]');

    const select=button=>{
      const filter=button.dataset.roomFilter;
      let visible=0;
      buttons.forEach(item=>{
        const active=item===button;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-selected',String(active));
      });
      cards.forEach(card=>{
        const show=filter==='all'||card.dataset.roomBuilding===filter;
        card.hidden=!show;
        card.classList.toggle('is-filtered-out',!show);
        if(show)visible++;
      });
      if(label)label.textContent=button.dataset.roomLabel||button.querySelector('strong')?.textContent||'Pokoje';
      if(count)count.textContent=inflect(visible);
      root.querySelectorAll("[data-room-building-copy]").forEach(copy=>{copy.hidden=copy.dataset.roomBuildingCopy!==filter;});
    };

    buttons.forEach(button=>button.addEventListener('click',()=>select(button)));
    const initial=buttons.find(button=>button.classList.contains('is-active'))||buttons[0];
    if(initial)select(initial);
  };

  const init=scope=>(scope||document).querySelectorAll('[data-dynamic-room-catalog]').forEach(initRoot);
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>init()):init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
/* PMW room card mobile media carousel 2026-09-03 */
(() => {
  const initRoomMediaCarousels = (root = document) => {
    root.querySelectorAll('[data-room-media-carousel]').forEach((carousel) => {
      if (carousel.dataset.roomMediaReady === 'true') return;
      carousel.dataset.roomMediaReady = 'true';
      const track = carousel.querySelector('[data-room-media-track]');
      const slides = [...carousel.querySelectorAll('[data-room-media-slide]')];
      const dots = [...carousel.querySelectorAll('[data-room-media-dot]')];
      if (!track || slides.length < 2) return;
      let active = 0;
      let frame = 0;
      const setActive = (index) => {
        active = ((index % slides.length) + slides.length) % slides.length;
        dots.forEach((dot, dotIndex) => {
          const selected = dotIndex === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-pressed', String(selected));
        });
      };
      const goTo = (index) => {
        const target = ((index % slides.length) + slides.length) % slides.length;
        track.scrollTo({ left: slides[target].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        setActive(target);
      };
      carousel.querySelector('[data-room-media-prev]')?.addEventListener('click', () => goTo(active - 1));
      carousel.querySelector('[data-room-media-next]')?.addEventListener('click', () => goTo(active + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const origin = slides[0].offsetLeft;
          const closest = slides.reduce((best, slide, index) => {
            const distance = Math.abs((slide.offsetLeft - origin) - track.scrollLeft);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          setActive(closest.index);
        });
      }, { passive: true });
      setActive(0);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initRoomMediaCarousels());
  else initRoomMediaCarousels();
  document.addEventListener('shopify:section:load', (event) => initRoomMediaCarousels(event.target));
})();
/* PMW mobile room cards carousel 2026-09-03 */
(() => {
  const initRoomListCarousels = (scope = document) => {
    scope.querySelectorAll('[data-dynamic-room-catalog]').forEach((root) => {
      if (root.dataset.roomListReady === 'true') return;
      const track = root.querySelector('[data-room-list-track]');
      const controls = root.querySelector('[data-room-list-controls]');
      const dotsWrap = root.querySelector('[data-room-list-dots]');
      if (!track || !controls || !dotsWrap) return;
      root.dataset.roomListReady = 'true';
      let cards = [];
      let dots = [];
      let active = 0;
      let frame = 0;
      const visibleCards = () => [...track.querySelectorAll('[data-room-card]')].filter((card) => !card.hidden && !card.classList.contains('is-filtered-out'));
      const setActive = (index) => {
        if (!cards.length) return;
        active = ((index % cards.length) + cards.length) % cards.length;
        dots.forEach((dot, dotIndex) => {
          const selected = dotIndex === active;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-pressed', String(selected));
        });
      };
      const goTo = (index, behavior = 'smooth') => {
        if (!cards.length) return;
        const target = ((index % cards.length) + cards.length) % cards.length;
        track.scrollTo({ left: cards[target].offsetLeft - cards[0].offsetLeft, behavior });
        setActive(target);
      };
      const rebuild = () => {
        cards = visibleCards();
        active = 0;
        dotsWrap.replaceChildren();
        dots = cards.map((card, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.dataset.roomListDot = String(index);
          dot.setAttribute('aria-label', `Pokój ${index + 1}`);
          dot.addEventListener('click', () => goTo(index));
          dotsWrap.appendChild(dot);
          return dot;
        });
        controls.hidden = cards.length < 2;
        track.scrollLeft = 0;
        setActive(0);
      };
      root.querySelector('[data-room-list-prev]')?.addEventListener('click', () => goTo(active - 1));
      root.querySelector('[data-room-list-next]')?.addEventListener('click', () => goTo(active + 1));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (!cards.length) return;
          const origin = cards[0].offsetLeft;
          const closest = cards.reduce((best, card, index) => {
            const distance = Math.abs((card.offsetLeft - origin) - track.scrollLeft);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          setActive(closest.index);
        });
      }, { passive: true });
      const observer = new MutationObserver(() => requestAnimationFrame(rebuild));
      [...track.querySelectorAll('[data-room-card]')].forEach((card) => observer.observe(card, { attributes: true, attributeFilter: ['hidden', 'class'] }));
      rebuild();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initRoomListCarousels());
  else initRoomListCarousels();
  document.addEventListener('shopify:section:load', (event) => initRoomListCarousels(event.target));
})();